/**
 * Capability metadata — category grouping and i18n key mapping.
 * Used by UserCapabilitiesModal for organized display.
 */

export const CAP_CATEGORIES = {
  routes: {
    labelKey: 'capCategory.routes',
    caps: ['routes.create', 'routes.edit', 'routes.archive', 'routes.delete', 'routes.viewTab'],
  },
  users: {
    labelKey: 'capCategory.users',
    caps: ['users.view', 'users.viewProfile', 'users.changeRole', 'users.kick', 'users.ban', 'users.viewAuditLog'],
  },
  gym: {
    labelKey: 'capCategory.gym',
    caps: ['gym.editProfile', 'gym.editBranding', 'gym.editVisibility', 'gym.editGeneral'],
  },
  mapsAndConfig: {
    labelKey: 'capCategory.mapsAndConfig',
    caps: ['maps.manage', 'difficulty.manage', 'holdColors.manage'],
  },
  tv: {
    labelKey: 'capCategory.tv',
    caps: ['tv.manage', 'tv.regenerateToken', 'tv.forceReleaseTimer'],
  },
  stats: {
    labelKey: 'capCategory.stats',
    caps: ['stats.viewSetterTab', 'stats.viewAdvanced'],
  },
  competitions: {
    labelKey: 'capCategory.competitions',
    caps: ['competitions.manage', 'competitions.viewClimberTimeline'],
  },
  series: {
    labelKey: 'capCategory.series',
    caps: ['series.manage'],
  },
  database: {
    labelKey: 'capCategory.database',
    caps: ['db.export', 'db.maintain'],
  },
  billing: {
    labelKey: 'capCategory.billing',
    caps: ['billing.view', 'billing.changeCurrency'],
  },
  intervalTimer: {
    labelKey: 'capCategory.intervalTimer',
    caps: ['intervalTimer.managePresets'],
  },
  events: {
    labelKey: 'capCategory.events',
    caps: ['events.manage', 'events.checkIn'],
  },
  mcp: {
    labelKey: 'capCategory.mcp',
    caps: ['mcp.read', 'mcp.write'],
  },
  spraywall: {
    labelKey: 'capCategory.spraywall',
    caps: ['spraywall.manage', 'spraywall.moderate'],
  },
};

/** i18n key helpers for capability labels and descriptions */
export function capLabelKey(cap) { return `caps.${cap}.label`; }
export function capDescKey(cap) { return `caps.${cap}.desc`; }
